export const MOCK_QUIZ_ME_DATA = {
  9491375: {
    quiz: [{
      questionTitle: 'Workflows are a powerful tool for marketers. Based on the video, which of the following is NOT an example of a valuable marketing workflow?',
      answers: [{
        answerOptionText: 'Automatically adding engaged email subscribers to a Facebook lookalike audience',
        correct: false,
        responseTitle: '',
        responseText: "Think about the primary focus of this video—it's all about marketing, not sales."
      }, {
        answerOptionText: 'Creating task queues to prioritize follow-ups based on deal size',
        correct: true,
        responseTitle: '',
        responseText: "Think about the primary focus of this video—it's all about marketing, not sales."
      }, {
        answerOptionText: 'Automatically sending targeted nurture emails when a contact visits a pricing page',
        correct: false,
        responseTitle: '',
        responseText: "Think about the primary focus of this video—it's all about marketing, not sales."
      }, {
        answerOptionText: 'Setting a contact as a non-marketing contact if they hard bounce or unsubscribe from messages',
        correct: false,
        responseTitle: '',
        responseText: "Think about the primary focus of this video—it's all about marketing, not sales."
      }]
    }, {
      questionTitle: 'A marketer wants to create a workflow to nurture leads who have shown high interest. According to the video, which action would be a valid trigger for this type of workflow?',
      answers: [{
        answerOptionText: 'When a prospect’s company size matches your ideal customer profile',
        correct: false,
        responseTitle: '',
        responseText: 'The video provides a few specific examples of engagement-based triggers. Which ones stand out?'
      }, {
        answerOptionText: 'When a contact downloads a resource or abandons a cart',
        correct: true,
        responseTitle: '',
        responseText: 'The video provides a few specific examples of engagement-based triggers. Which ones stand out?'
      }, {
        answerOptionText: "When a sales representative manually updates the contact's lifecycle stage to 'MQL'",
        correct: false,
        responseTitle: '',
        responseText: 'The video provides a few specific examples of engagement-based triggers. Which ones stand out?'
      }, {
        answerOptionText: 'When a contact submits a form that requests a demo',
        correct: false,
        responseTitle: '',
        responseText: 'The video provides a few specific examples of engagement-based triggers. Which ones stand out?'
      }]
    }, {
      questionTitle: 'What is the primary benefit of using a workflow to automatically manage your marketing contacts?',
      answers: [{
        answerOptionText: 'It instantly qualifies leads for the sales team',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the financial side of your marketing efforts and the total number of contacts you are billed for.'
      }, {
        answerOptionText: 'It allows you to focus on strategic work by removing manual tasks',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the financial side of your marketing efforts and the total number of contacts you are billed for.'
      }, {
        answerOptionText: 'It keeps your billable contact total accurate and ensures you are only paying for the contacts you plan to engage with',
        correct: true,
        responseTitle: '',
        responseText: 'Think about the financial side of your marketing efforts and the total number of contacts you are billed for.'
      }, {
        answerOptionText: 'It automatically assigns a lead score to each contact based on their behavior',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the financial side of your marketing efforts and the total number of contacts you are billed for.'
      }]
    }, {
      questionTitle: 'Which statement accurately describes the purpose of an ad audience, according to the video?',
      answers: [{
        answerOptionText: "It's a way to track a customer's entire journey, from first touch to conversion",
        correct: false,
        responseTitle: '',
        responseText: "The video gives a very specific definition of what an ad audience is and what it's used for."
      }, {
        answerOptionText: 'It’s a targeted group of people who see your Facebook, Google, and LinkedIn ads',
        correct: true,
        responseTitle: '',
        responseText: "The video gives a very specific definition of what an ad audience is and what it's used for."
      }, {
        answerOptionText: 'It’s a list of contacts that have been automatically set as non-marketing contacts',
        correct: false,
        responseTitle: '',
        responseText: "The video gives a very specific definition of what an ad audience is and what it's used for."
      }, {
        answerOptionText: 'It’s a way to send personalized emails to your contacts based on their actions',
        correct: false,
        responseTitle: '',
        responseText: "The video gives a very specific definition of what an ad audience is and what it's used for."
      }]
    }],
    errorMessage: undefined,
    summary: {
      description: 'This video introduces top workflows in HubSpot, showing marketers how to use automation to nurture leads, manage ad audiences and maintain marketing contacts.',
      sections: [{
        timestamp: 4,
        title: 'Introduction to Workflows',
        bullets: ['Automation saves time, keeps data clean, and frees marketers to focus on more strategic work.', "HubSpot's Workflows trigger automated actions based on criteria, eliminating manual tasks and ensuring consistency for marketers."]
      }, {
        timestamp: 33,
        title: 'Nurture Email Workflows',
        bullets: ['Create nurture email workflows that send targeted messages when contacts download resources or visit important pages.', 'Trigger-based emails deliver timely, relevant content automatically, improving lead engagement without manual intervention or delays.']
      }, {
        timestamp: 53,
        title: 'Ad Audience Management',
        bullets: ['Use workflows to automatically add or remove contacts from Facebook, Google, or LinkedIn ad audiences based on engagement.', 'Build lookalike audiences from engaged subscribers and exclude customers to avoid wasted spend and focus budgets effectively.']
      }, {
        timestamp: 77,
        title: 'Marketing Contacts Management',
        bullets: ['Automatically set contacts as marketing when they engage and switch them to non-marketing when they bounce or unsubscribe.', 'Keeping marketing contacts accurate reduces costs and ensures your automation lists stay targeted and compliant.']
      }]
    }
  },
  9605393: {
    quiz: [{
      questionTitle: "The video explains that AI can take the 'heavy lifting' out of setting up marketing automation. Which of the following is an example of AI simplifying this process?",
      answers: [{
        answerOptionText: 'AI automatically sends every marketing email without human intervention',
        correct: false,
        responseTitle: '',
        responseText: 'Remember, AI is presented as a helpful assistant in the setup process, not a complete replacement for the marketer.'
      }, {
        answerOptionText: 'AI generates enrollment triggers and workflow actions to simplify the setup',
        correct: true,
        responseTitle: '',
        responseText: 'Remember, AI is presented as a helpful assistant in the setup process, not a complete replacement for the marketer.'
      }, {
        answerOptionText: 'AI identifies every company that visits your website, regardless of your target market',
        correct: false,
        responseTitle: '',
        responseText: 'Remember, AI is presented as a helpful assistant in the setup process, not a complete replacement for the marketer.'
      }, {
        answerOptionText: 'AI autonomously creates your entire marketing campaign from scratch',
        correct: false,
        responseTitle: '',
        responseText: 'Remember, AI is presented as a helpful assistant in the setup process, not a complete replacement for the marketer.'
      }]
    }, {
      questionTitle: 'How can AI help with content creation for your marketing emails?',
      answers: [{
        answerOptionText: 'It can research and generate brand-new case studies for your emails',
        correct: false,
        responseTitle: '',
        responseText: "Think about the tools mentioned in the video that help overcome common creative challenges, like writer's block."
      }, {
        answerOptionText: 'It can rewrite, expand, shorten, or change the tone of your copy and generate subject lines',
        correct: true,
        responseTitle: '',
        responseText: "Think about the tools mentioned in the video that help overcome common creative challenges, like writer's block."
      }, {
        answerOptionText: 'It can design and code an entirely new email template for you',
        correct: false,
        responseTitle: '',
        responseText: "Think about the tools mentioned in the video that help overcome common creative challenges, like writer's block."
      }, {
        answerOptionText: 'It provides a list of best-performing emails from other companies in your industry',
        correct: false,
        responseTitle: '',
        responseText: "Think about the tools mentioned in the video that help overcome common creative challenges, like writer's block."
      }]
    }, {
      questionTitle: 'What is the key difference between marketing automation and AI in marketing, as described in the video?',
      answers: [{
        answerOptionText: 'Marketing automation is for small companies, while AI is for large enterprises',
        correct: false,
        responseTitle: '',
        responseText: 'Recall the definitions provided at the beginning of the video. One is about software; the other is about advanced analysis.'
      }, {
        answerOptionText: 'Marketing automation is a software for repetitive tasks, while AI uses advanced analysis to make decisions and take action',
        correct: true,
        responseTitle: '',
        responseText: 'Recall the definitions provided at the beginning of the video. One is about software; the other is about advanced analysis.'
      }, {
        answerOptionText: 'Marketing automation is a new technology, while AI has been used for decades',
        correct: false,
        responseTitle: '',
        responseText: 'Recall the definitions provided at the beginning of the video. One is about software; the other is about advanced analysis.'
      }, {
        answerOptionText: 'Marketing automation is for B2B, and AI is for B2C',
        correct: false,
        responseTitle: '',
        responseText: 'Recall the definitions provided at the beginning of the video. One is about software; the other is about advanced analysis.'
      }]
    }, {
      questionTitle: "How can the AI-powered 'buyer intent' tool help a marketer's segmentation strategy?",
      answers: [{
        answerOptionText: 'It allows the marketer to manually add companies to a list based on their industry',
        correct: false,
        responseTitle: '',
        responseText: "The name of the tool, 'buyer intent,' is a big clue. What does it help you understand about your website visitors?"
      }, {
        answerOptionText: 'It helps the marketer create a list of companies that have already converted',
        correct: false,
        responseTitle: '',
        responseText: "The name of the tool, 'buyer intent,' is a big clue. What does it help you understand about your website visitors?"
      }, {
        answerOptionText: 'It reveals which companies in a marketer’s target market are visiting their website, allowing them to be added to the CRM and workflows',
        correct: true,
        responseTitle: '',
        responseText: "The name of the tool, 'buyer intent,' is a big clue. What does it help you understand about your website visitors?"
      }, {
        answerOptionText: 'It automatically creates an ideal customer profile based on your existing customers',
        correct: false,
        responseTitle: '',
        responseText: "The name of the tool, 'buyer intent,' is a big clue. What does it help you understand about your website visitors?"
      }]
    }],
    summary: {
      description: 'The video explores how AI enhances marketing automation, including segmentation, content creation and workflow building to improve productivity.',
      sections: [{
        timestamp: 4,
        title: 'AI and Automation Overview',
        bullets: ['AI complements marketing automation, helping teams build scalable processes and increase productivity without extensive setup.', 'Automation tools handle repetitive tasks while AI analyzes data to make decisions and take actions automatically.']
      }, {
        timestamp: 42,
        title: 'Segmenting Audiences with AI',
        bullets: ['Use AI-driven buyer intent data to identify companies visiting your website even before they convert.', 'Add identified companies to your CRM and enroll them in workflows to begin targeted outreach immediately.']
      }, {
        timestamp: 58,
        title: 'Creating Content with AI',
        bullets: ['AI copy tools help you rewrite, expand, shorten, or adjust the tone of your marketing emails.', "Generate AI-powered subject lines and images to overcome writer's block and create more engaging content."]
      }, {
        timestamp: 77,
        title: 'Building Workflows with AI',
        bullets: ['AI can suggest workflow enrollment triggers and actions, simplifying setup and speeding execution for marketers.', 'Combining AI with workflows enables fast audience segmentation, content delivery, and automation in minutes, not hours.']
      }, {
        timestamp: 94,
        title: 'Conclusion',
        bullets: ['AI-powered marketing improves segmentation, content creation, and workflow setup, making automation more accessible and efficient.', 'Explore AI tools to engage and nurture leads, enhancing productivity and results across your marketing efforts.']
      }]
    },
    errorMessage: undefined
  },
  8633750: {
    quiz: [{
      questionTitle: "The video states that deal stages are your 'roadmap to revenue.' What is a key practice for making your deal stages an effective tool for a predictable revenue machine?",
      answers: [{
        answerOptionText: 'Leaving the deal stages in their default settings to ensure consistency',
        correct: false,
        responseTitle: '',
        responseText: 'The video emphasizes the need for your HubSpot setup to accurately reflect your real-world sales process.'
      }, {
        answerOptionText: 'Assigning one sales rep per deal to avoid confusion',
        correct: false,
        responseTitle: '',
        responseText: 'The video emphasizes the need for your HubSpot setup to accurately reflect your real-world sales process.'
      }, {
        answerOptionText: 'Refining and configuring the deal pipeline to match your actual sales process',
        correct: true,
        responseTitle: '',
        responseText: 'The video emphasizes the need for your HubSpot setup to accurately reflect your real-world sales process.'
      }, {
        answerOptionText: 'Manually updating deals to reflect progress at the end of each business day',
        correct: false,
        responseTitle: '',
        responseText: 'The video emphasizes the need for your HubSpot setup to accurately reflect your real-world sales process.'
      }]
    }, {
      questionTitle: 'How can automation dramatically increase the percentage of time a sales rep spends actually selling?',
      answers: [{
        answerOptionText: 'By automatically hiring and onboarding new sales reps',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the routine, time-consuming tasks that sales reps typically perform and how automation can take those off their plate.'
      }, {
        answerOptionText: 'By setting up workflows to automatically move deals, creating task queues for follow-ups, and using sequences to nurture prospects',
        correct: true,
        responseTitle: '',
        responseText: 'Think about the routine, time-consuming tasks that sales reps typically perform and how automation can take those off their plate.'
      }, {
        answerOptionText: 'By generating a report of the best-performing sales reps to replicate their strategies',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the routine, time-consuming tasks that sales reps typically perform and how automation can take those off their plate.'
      }, {
        answerOptionText: 'By autonomously closing deals once a prospect is ready to buy',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the routine, time-consuming tasks that sales reps typically perform and how automation can take those off their plate.'
      }]
    }, {
      questionTitle: 'What is the primary function of AI meeting assistance, as described in the video?',
      answers: [{
        answerOptionText: 'To schedule all future meetings for the sales team',
        correct: false,
        responseTitle: '',
        responseText: "The purpose of this tool is to provide support for a sales rep's actual conversations with prospects."
      }, {
        answerOptionText: 'To prep for meetings, summarize calls, capture action items, and plot next steps',
        correct: true,
        responseTitle: '',
        responseText: "The purpose of this tool is to provide support for a sales rep's actual conversations with prospects."
      }, {
        answerOptionText: 'To autonomously run meetings in place of a sales representative',
        correct: false,
        responseTitle: '',
        responseText: "The purpose of this tool is to provide support for a sales rep's actual conversations with prospects."
      }, {
        answerOptionText: 'To automatically send follow-up emails after every meeting',
        correct: false,
        responseTitle: '',
        responseText: "The purpose of this tool is to provide support for a sales rep's actual conversations with prospects."
      }]
    }, {
      questionTitle: 'Why is it important to use required properties at each stage of your deal pipeline?',
      answers: [{
        answerOptionText: 'To ensure that all sales reps are using the same email signature',
        correct: false,
        responseTitle: '',
        responseText: "The video humorously points out a common challenge with sales reps: remembering to input key information. What's the solution to this?"
      }, {
        answerOptionText: 'To prevent sales reps from moving a deal backward in the pipeline',
        correct: false,
        responseTitle: '',
        responseText: "The video humorously points out a common challenge with sales reps: remembering to input key information. What's the solution to this?"
      }, {
        answerOptionText: 'To ensure that the sales team collects consistent and critical data at every stage',
        correct: true,
        responseTitle: '',
        responseText: "The video humorously points out a common challenge with sales reps: remembering to input key information. What's the solution to this?"
      }, {
        answerOptionText: 'To automatically forecast your revenue based on the total number of deals',
        correct: false,
        responseTitle: '',
        responseText: "The video humorously points out a common challenge with sales reps: remembering to input key information. What's the solution to this?"
      }]
    }],
    summary: {
      description: 'This tutorial teaches sales teams to get the most from Sales Hub by optimizing deal pipelines, automating tasks and using AI tools.',
      sections: [{
        timestamp: 4,
        title: 'Why Tools Matter',
        bullets: ['Successful sales teams use the right tools and know-how to exceed quotas, not just raw talent.', 'Sales Hub contains everything you need to close more deals, but most teams underuse its capabilities.']
      }, {
        timestamp: 34,
        title: 'Optimizing Deal Pipelines',
        bullets: ['Customise your deal stages to reflect your unique sales process from initial contact to closed won.', 'Use deal properties and required fields to capture critical information, ensuring consistent data entry from reps.', 'Track deal movement with automation to identify bottlenecks and build a predictable revenue machine for forecasting.']
      }, {
        timestamp: 87,
        title: 'Leveraging Automation',
        bullets: ['Automation frees sales reps to focus on high-value selling activities instead of administrative tasks and daily busywork.', 'Set workflows to move deals based on triggers, create task queues, and use sequences for nurturing prospects.', 'Meeting tools eliminate scheduling back-and-forth, significantly increasing the percentage of time reps spend actually selling.']
      }, {
        timestamp: 123,
        title: 'AI-Powered Sales Tools',
        bullets: ['AI meeting assistants prep for meetings, summarize calls, capture action items, and help plan next steps.', 'Conversation intelligence surfaces coaching opportunities from real sales conversations, enabling targeted training for reps to improve performance.', 'Predictive scores and the prospecting agent focus reps on deals most likely to close, automating research and follow-ups.']
      }, {
        timestamp: 166,
        title: 'Final Thoughts',
        bullets: ['Sales Hub is a competitive advantage; using automation and AI turns good closers into unstoppable deal-closing machines.', 'Harness the full potential of Sales Hub to forecast accurately, close deals faster, and outperform competitors.']
      }]
    },
    errorMessage: undefined
  },
  8488213: {
    quiz: [{
      questionTitle: 'When using the HubSpot Prospecting Agent, what is the most important reason to create multiple, detailed selling profiles?',
      answers: [{
        answerOptionText: "To ensure the agent's output is highly personalized and tailored to specific buyer personas",
        correct: true,
        responseTitle: '',
        responseText: "The quality of the agent's output is directly tied to the quality of your input. What does a high-quality input look like?"
      }, {
        answerOptionText: 'To allow the agent to automatically generate new product descriptions from your website content',
        correct: false,
        responseTitle: '',
        responseText: "The quality of the agent's output is directly tied to the quality of your input. What does a high-quality input look like?"
      }, {
        answerOptionText: 'To test which product descriptions are the most popular with your current customers',
        correct: false,
        responseTitle: '',
        responseText: "The quality of the agent's output is directly tied to the quality of your input. What does a high-quality input look like?"
      }, {
        answerOptionText: 'To enable the agent to operate in fully autonomous mode from the start',
        correct: false,
        responseTitle: '',
        responseText: "The quality of the agent's output is directly tied to the quality of your input. What does a high-quality input look like?"
      }]
    }, {
      questionTitle: "What is the recommended initial approach for using the Prospecting Agent's autonomous mode settings?",
      answers: [{
        answerOptionText: 'Start in fully autonomous mode to achieve maximum efficiency and scale immediately',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the best way to get to know and trust a new, powerful tool.'
      }, {
        answerOptionText: "Begin with semi-autonomous mode to first review and learn from the agent's outreach quality",
        correct: true,
        responseTitle: '',
        responseText: 'Think about the best way to get to know and trust a new, powerful tool.'
      }, {
        answerOptionText: 'Use autonomous mode for all contacts, but only for low-priority leads',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the best way to get to know and trust a new, powerful tool.'
      }, {
        answerOptionText: 'Create two separate selling profiles—one for each mode',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the best way to get to know and trust a new, powerful tool.'
      }]
    }, {
      questionTitle: 'When enrolling contacts in a prospecting sequence through an automated workflow, in which mode will the agent always operate?',
      answers: [{
        answerOptionText: 'It will operate in whichever mode is set in the selling profile',
        correct: false,
        responseTitle: '',
        responseText: "This is a specific rule mentioned in a 'bonus tip.' It's a safety net for when you use a workflow to enroll contacts."
      }, {
        answerOptionText: 'In fully autonomous mode, as the workflow is already an automation',
        correct: false,
        responseTitle: '',
        responseText: "This is a specific rule mentioned in a 'bonus tip.' It's a safety net for when you use a workflow to enroll contacts."
      }, {
        answerOptionText: 'In semi-autonomous mode, regardless of the selling profile setting',
        correct: true,
        responseTitle: '',
        responseText: "This is a specific rule mentioned in a 'bonus tip.' It's a safety net for when you use a workflow to enroll contacts."
      }, {
        answerOptionText: 'It will not enroll contacts through automated workflows; they must be added manually',
        correct: false,
        responseTitle: '',
        responseText: "This is a specific rule mentioned in a 'bonus tip.' It's a safety net for when you use a workflow to enroll contacts."
      }]
    }, {
      questionTitle: "Which of the following is an example of an integrated tool that can boost the prospecting agent's effectiveness?",
      answers: [{
        answerOptionText: 'An external sales engagement platform for sending mass emails',
        correct: false,
        responseTitle: '',
        responseText: "The video mentions a list of items that can be included in your agent's outreach to make it more impactful."
      }, {
        answerOptionText: 'HubSpot documents and meeting links to enhance your call-to-actions',
        correct: true,
        responseTitle: '',
        responseText: "The video mentions a list of items that can be included in your agent's outreach to make it more impactful."
      }, {
        answerOptionText: 'A live chat tool to have real-time conversations with prospects',
        correct: false,
        responseTitle: '',
        responseText: "The video mentions a list of items that can be included in your agent's outreach to make it more impactful."
      }, {
        answerOptionText: 'A form builder to capture prospect information on your website',
        correct: false,
        responseTitle: '',
        responseText: "The video mentions a list of items that can be included in your agent's outreach to make it more impactful."
      }]
    }],
    summary: {
      description: "This guide shows how to maximize HubSpot's prospecting agent, building detailed profiles, optimizing settings, integrating tools and auto-enrollment.",
      sections: [{
        timestamp: 4,
        title: 'Transforming the Prospecting Agent',
        bullets: ['Transform the prospecting agent into a tireless AI sales development rep delivering qualified pipeline autonomously.', "Many teams barely scratch the agent's capabilities; strategic approaches make it a true extension of your sales team."]
      }, {
        timestamp: 33,
        title: 'Creating Selling Profiles',
        bullets: ['Develop multiple detailed selling profiles with product descriptions, value propositions, personas, and competitive advantages carefully.', 'Collaborate with marketing and sales to refine automatically generated content for better targeting and engagement.']
      }, {
        timestamp: 64,
        title: 'Optimizing Autonomous Mode',
        bullets: ["Start in semi-autonomous mode to review the agent's outreach; transition to fully autonomous mode once confident.", "Configure email signatures correctly and note that send times align with the contact's time zone."]
      }, {
        timestamp: 99,
        title: 'Integrating Tools and Data',
        bullets: ['Equip the agent with meeting links, documents, and relevant URLs to strengthen calls to action.', 'Combine the agent with guided actions and conversation intelligence for a comprehensive prospecting workflow experience.']
      }, {
        timestamp: 117,
        title: 'Custom Auto-enrollment',
        bullets: ['Set custom auto-enrollment rules to automatically enroll contacts based on properties, behaviors, or engagement levels.', 'Ensure automated enrollments run in semi-autonomous mode and avoid overlapping automations to prevent duplicate emails.']
      }, {
        timestamp: 152,
        title: 'Conclusion',
        bullets: ['Implement these strategies to transform the prospecting agent into a powerful extension of your sales team.', 'Free reps to focus on closing deals while the agent handles research and initial outreach at scale.']
      }]
    },
    errorMessage: undefined
  },
  8034589: {
    quiz: [{
      questionTitle: 'What is a key benefit of the live Sales Hub workshops provided in the guided onboarding program?',
      answers: [{
        answerOptionText: 'They replace the need for individual sales coaching',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the value of a live, interactive session with other people rather than a pre-recorded video.'
      }, {
        answerOptionText: 'They offer a chance to ask specific sales questions and gain insights from others in your group',
        correct: true,
        responseTitle: '',
        responseText: 'Think about the value of a live, interactive session with other people rather than a pre-recorded video.'
      }, {
        answerOptionText: 'They automatically close deals for you after you complete the program',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the value of a live, interactive session with other people rather than a pre-recorded video.'
      }, {
        answerOptionText: 'They provide you with a pre-built deal pipeline to use immediately',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the value of a live, interactive session with other people rather than a pre-recorded video.'
      }]
    }, {
      questionTitle: 'A team member wants to learn how to use AI sales tools. Where would they find a pre-curated video playlist on this topic?',
      answers: [{
        answerOptionText: 'Within the live workshop recordings',
        correct: false,
        responseTitle: '',
        responseText: 'The program offers a specific resource for learning about different sales topics through video content.'
      }, {
        answerOptionText: 'In the private HubSpot Academy guided onboarding forum',
        correct: false,
        responseTitle: '',
        responseText: 'The program offers a specific resource for learning about different sales topics through video content.'
      }, {
        answerOptionText: 'In the hands-on workbook provided with the program',
        correct: false,
        responseTitle: '',
        responseText: 'The program offers a specific resource for learning about different sales topics through video content.'
      }, {
        answerOptionText: 'In the curated, on-demand sales hub playlist',
        correct: true,
        responseTitle: '',
        responseText: 'The program offers a specific resource for learning about different sales topics through video content.'
      }]
    }, {
      questionTitle: 'What is one key purpose of the hands-on workbook provided in the Sales Hub Essentials program?',
      answers: [{
        answerOptionText: 'To serve as a detailed video of all the live workshops',
        correct: false,
        responseTitle: '',
        responseText: 'The workbook is a practical tool for taking action. What kind of actions are mentioned in the video?'
      }, {
        answerOptionText: 'To help you with key sales tasks like setting up your deal stages and automating sales outreach',
        correct: true,
        responseTitle: '',
        responseText: 'The workbook is a practical tool for taking action. What kind of actions are mentioned in the video?'
      }, {
        answerOptionText: "To provide a list of all your sales reps' responsibilities",
        correct: false,
        responseTitle: '',
        responseText: 'The workbook is a practical tool for taking action. What kind of actions are mentioned in the video?'
      }, {
        answerOptionText: 'To act as a forum for interacting with other companies in the program',
        correct: false,
        responseTitle: '',
        responseText: 'The workbook is a practical tool for taking action. What kind of actions are mentioned in the video?'
      }]
    }, {
      questionTitle: "What happens if you can't make one of the live workshop sessions?",
      answers: [{
        answerOptionText: 'You will be provided with a recording of the missed session',
        correct: true,
        responseTitle: '',
        responseText: 'The video offers a clear solution for those who cannot attend the live sessions.'
      }, {
        answerOptionText: 'You must reschedule with the HubSpot Academy professors',
        correct: false,
        responseTitle: '',
        responseText: 'The video offers a clear solution for those who cannot attend the live sessions.'
      }, {
        answerOptionText: "You can't get credit for that part of the bootcamp",
        correct: false,
        responseTitle: '',
        responseText: 'The video offers a clear solution for those who cannot attend the live sessions.'
      }, {
        answerOptionText: 'You must complete an alternative assignment to cover the content',
        correct: false,
        responseTitle: '',
        responseText: 'The video offers a clear solution for those who cannot attend the live sessions.'
      }]
    }],
    summary: {
      description: 'The onboarding overview highlights the Sales Hub Essentials Bootcamp with interactive workshops, recordings, resources and support to hit sales goals.',
      sections: [{
        timestamp: 3,
        title: 'Welcome & Bootcamp Overview',
        bullets: ['Welcome to Sales Hub Essentials guided onboarding, a series of live workshops and resources for new users.', 'Sales Hub Essentials Bootcamp features interactive sessions led by HubSpot professors to build pipelines and close deals.']
      }, {
        timestamp: 9,
        title: 'Interactive Workshops',
        bullets: ['Workshops cover lead pipeline building, the sales workspace, prospecting agent, meetings tool, and sequences sessions.', 'Interactive sessions allow you to ask questions and learn from instructors and peers in real time.']
      }, {
        timestamp: 40,
        title: 'Flexibility & Team Participation',
        bullets: ['If you cannot attend live, recorded workshop versions are available to watch at your convenience.', 'Invite your team members to participate in live sessions so onboarding is a shared responsibility.']
      }, {
        timestamp: 60,
        title: 'On-Demand Resources',
        bullets: ['Guided onboarding provides a curated on-demand playlist covering handling objections, pipeline reports, and AI sales tools.', 'Use the workbook and private forum to practice tasks like deal stages and connect with cohort peers.']
      }, {
        timestamp: 81,
        title: 'Achieving Sales Goals',
        bullets: ['Sales Hub Essentials equips you to build more pipeline and close deals confidently with support and community.', "By the end, you'll have tools, knowledge, and support to hit sales goals easier and faster."]
      }]
    },
    errorMessage: undefined
  },
  8034588: {
    quiz: [{
      questionTitle: 'What is the primary focus of the Marketing Hub Essentials Bootcamp workshops, as described in the video?',
      answers: [{
        answerOptionText: 'To help marketers master lead generation and marketing automation',
        correct: true,
        responseTitle: '',
        responseText: 'Think about the main goals of a marketing team and how the bootcamp helps you achieve them.'
      }, {
        answerOptionText: 'To build a sales pipeline and close more deals',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the main goals of a marketing team and how the bootcamp helps you achieve them.'
      }, {
        answerOptionText: 'To onboard new team members on general HubSpot portal features',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the main goals of a marketing team and how the bootcamp helps you achieve them.'
      }, {
        answerOptionText: 'To teach you how to integrate all your social media accounts with HubSpot',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the main goals of a marketing team and how the bootcamp helps you achieve them.'
      }]
    }, {
      questionTitle: "The video mentions a 'curated on-demand marketing playlist.' What kind of content would a user find in this playlist?",
      answers: [{
        answerOptionText: 'Live, interactive sessions with other companies',
        correct: false,
        responseTitle: '',
        responseText: "The term 'on-demand' implies a library of content you can access anytime. What kind of content is mentioned?"
      }, {
        answerOptionText: 'Videos on topics like email marketing, integrations, and creating lead nurturing workflows',
        correct: true,
        responseTitle: '',
        responseText: "The term 'on-demand' implies a library of content you can access anytime. What kind of content is mentioned?"
      }, {
        answerOptionText: 'A hands-on workbook for key marketing tasks',
        correct: false,
        responseTitle: '',
        responseText: "The term 'on-demand' implies a library of content you can access anytime. What kind of content is mentioned?"
      }, {
        answerOptionText: 'Recordings of the live workshops',
        correct: false,
        responseTitle: '',
        responseText: "The term 'on-demand' implies a library of content you can access anytime. What kind of content is mentioned?"
      }]
    }, {
      questionTitle: 'What is the benefit of the private HubSpot Academy guided onboarding forum mentioned in the video?',
      answers: [{
        answerOptionText: 'It provides a place to access all the live workshop recordings',
        correct: false,
        responseTitle: '',
        responseText: "The forum is described as a community space. What's the main benefit of that kind of space?"
      }, {
        answerOptionText: 'It is a platform to brainstorm marketing emails and campaigns with your own team',
        correct: false,
        responseTitle: '',
        responseText: "The forum is described as a community space. What's the main benefit of that kind of space?"
      }, {
        answerOptionText: 'It allows you to ask questions to the HubSpot Academy professors directly',
        correct: false,
        responseTitle: '',
        responseText: "The forum is described as a community space. What's the main benefit of that kind of space?"
      }, {
        answerOptionText: 'It provides a community where you can interact and learn from other companies in your bootcamp cohort',
        correct: true,
        responseTitle: '',
        responseText: "The forum is described as a community space. What's the main benefit of that kind of space?"
      }]
    }, {
      questionTitle: 'Who can attend the live workshops provided in the Marketing Hub Essentials Bootcamp?',
      answers: [{
        answerOptionText: 'Only the person who purchased the bootcamp',
        correct: false,
        responseTitle: '',
        responseText: 'This is a bonus benefit that extends the value of the workshops beyond the individual who purchased the program.'
      }, {
        answerOptionText: 'Only the marketing team members from the purchasing company',
        correct: false,
        responseTitle: '',
        responseText: 'This is a bonus benefit that extends the value of the workshops beyond the individual who purchased the program.'
      }, {
        answerOptionText: "Any team member from your portal who is invited, as onboarding doesn't have to be one person's responsibility",
        correct: true,
        responseTitle: '',
        responseText: 'This is a bonus benefit that extends the value of the workshops beyond the individual who purchased the program.'
      }, {
        answerOptionText: 'Anyone with a HubSpot account, regardless of their subscription level',
        correct: false,
        responseTitle: '',
        responseText: 'This is a bonus benefit that extends the value of the workshops beyond the individual who purchased the program.'
      }]
    }],
    summary: {
      description: 'This overview introduces Marketing Hub Essentials Bootcamp, covering interactive workshops, recordings, resources and community support for marketing success.',
      sections: [{
        timestamp: 3,
        title: 'Introduction & Bootcamp Purpose',
        bullets: ['Marketing Hub Essentials Bootcamp offers guided onboarding for new Marketing Hub customers, helping them get started.', 'Live workshops teach lead generation and marketing automation fundamentals with HubSpot Academy professors, guiding you.']
      }, {
        timestamp: 9,
        title: 'Interactive Marketing Workshops',
        bullets: ['Interactive sessions let you ask marketing questions and learn from peers to improve campaigns together.', 'Workshops cover generating leads through ads and forms and automating marketing via AI and workflows.']
      }, {
        timestamp: 36,
        title: 'Flexible Participation',
        bullets: ['If you cannot attend live, recorded versions of workshops are available for flexible viewing later.', 'Invite team members to join live sessions so marketing onboarding is a collaborative effort together.']
      }, {
        timestamp: 52,
        title: 'Curated Resources & Forum',
        bullets: ['Get a curated on-demand playlist covering email marketing, integrations, social accounts, and nurturing workflows topics.', 'Use the workbook and private forum to plan campaigns, brainstorm emails, and connect with other companies.']
      }, {
        timestamp: 82,
        title: 'Final Outcomes',
        bullets: ["By the end of the bootcamp you'll generate more leads and automate marketing confidently and quickly.", 'Live workshops, videos, workbooks, and community support give you knowledge and tools to hit marketing goals.']
      }]
    },
    errorMessage: undefined
  },
  7599256: {
    quiz: [{
      questionTitle: "What is the key function of conditional stage properties in HubSpot's Smart CRM?",
      answers: [{
        answerOptionText: 'They allow you to automatically move a record to the next stage of the pipeline',
        correct: false,
        responseTitle: '',
        responseText: "Think about how this tool ensures you get the right data at the right time. What does it 'enforce' at a specific point in the process?"
      }, {
        answerOptionText: 'They enable you to set rules that prevent records from being moved backward in a pipeline',
        correct: false,
        responseTitle: '',
        responseText: "Think about how this tool ensures you get the right data at the right time. What does it 'enforce' at a specific point in the process?"
      }, {
        answerOptionText: 'They require or prompt for specific properties as a record advances through the pipeline, ensuring critical data is captured',
        correct: true,
        responseTitle: '',
        responseText: "Think about how this tool ensures you get the right data at the right time. What does it 'enforce' at a specific point in the process?"
      }, {
        answerOptionText: 'They automatically alert a sales rep when there is missing data in a record',
        correct: false,
        responseTitle: '',
        responseText: "Think about how this tool ensures you get the right data at the right time. What does it 'enforce' at a specific point in the process?"
      }]
    }, {
      questionTitle: 'What is the main purpose of implementing pipeline rules in your CRM?',
      answers: [{
        answerOptionText: 'To automate complex checks and actions that go beyond basic rules',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the rules of a game. What do they do? How do they control what can or cannot happen?'
      }, {
        answerOptionText: 'To ensure critical data is captured consistently when a record advances',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the rules of a game. What do they do? How do they control what can or cannot happen?'
      }, {
        answerOptionText: 'To enforce operational guardrails and control how records move within your pipeline',
        correct: true,
        responseTitle: '',
        responseText: 'Think about the rules of a game. What do they do? How do they control what can or cannot happen?'
      }, {
        answerOptionText: 'To provide a way to tell reps of missing data or to create related records',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the rules of a game. What do they do? How do they control what can or cannot happen?'
      }]
    }, {
      questionTitle: 'How can workflows be used to handle situations that go beyond basic pipeline rules?',
      answers: [{
        answerOptionText: 'By stopping records from jumping ahead to a later stage in the pipeline',
        correct: false,
        responseTitle: '',
        responseText: 'Workflows are the most sophisticated of the three tools. What kinds of complex, multi-step actions can they perform?'
      }, {
        answerOptionText: 'By limiting who has permission to edit records in a specific stage',
        correct: false,
        responseTitle: '',
        responseText: 'Workflows are the most sophisticated of the three tools. What kinds of complex, multi-step actions can they perform?'
      }, {
        answerOptionText: 'By automating actions such as telling reps about missing data, creating related records, or triggering tasks',
        correct: true,
        responseTitle: '',
        responseText: 'Workflows are the most sophisticated of the three tools. What kinds of complex, multi-step actions can they perform?'
      }, {
        answerOptionText: 'By making certain properties required before a record can move forward',
        correct: false,
        responseTitle: '',
        responseText: 'Workflows are the most sophisticated of the three tools. What kinds of complex, multi-step actions can they perform?'
      }]
    }, {
      questionTitle: 'What is the overarching goal of enforcing processes in HubSpot?',
      answers: [{
        answerOptionText: 'To ensure the entire team follows the same script when talking to customers',
        correct: false,
        responseTitle: '',
        responseText: 'The video concludes with a summary of the broad, strategic benefits of enforcing processes. What is the ultimate outcome?'
      }, {
        answerOptionText: 'To reduce the overall number of records in the CRM',
        correct: false,
        responseTitle: '',
        responseText: 'The video concludes with a summary of the broad, strategic benefits of enforcing processes. What is the ultimate outcome?'
      }, {
        answerOptionText: 'To build a predictable, scalable, and efficient operation that removes friction and ensures data integrity',
        correct: true,
        responseTitle: '',
        responseText: 'The video concludes with a summary of the broad, strategic benefits of enforcing processes. What is the ultimate outcome?'
      }, {
        answerOptionText: 'To completely automate the sales and service process, removing the need for manual work',
        correct: false,
        responseTitle: '',
        responseText: 'The video concludes with a summary of the broad, strategic benefits of enforcing processes. What is the ultimate outcome?'
      }]
    }],
    summary: {
      description: 'The video explains three ways to enforce processes in HubSpot: conditional stage properties, pipeline rules and workflows for efficiency.',
      sections: [{
        timestamp: 4,
        title: 'Why Process Enforcement Matters',
        bullets: ['HubSpot Smart CRM helps build and enforce consistent sales and service processes to prevent breakdowns.', 'Consistent processes drive efficiency and ensure teams provide a predictable, high-quality customer experience every time.']
      }, {
        timestamp: 20,
        title: 'Conditional Stage Properties',
        bullets: ['Embed data collection into pipeline stages by requiring specific properties as records progress forward smoothly.', 'Conditional properties ensure critical data is captured consistently, improving data quality and reducing follow-ups significantly.']
      }, {
        timestamp: 38,
        title: 'Pipeline Rules Guardrails',
        bullets: ['Configure pipeline rules to prevent stage jumps, backward movement, and enforce approvals where needed consistently.', 'Guardrails maintain process integrity at scale, ensuring everyone follows your defined sales and service flows.']
      }, {
        timestamp: 57,
        title: 'Automated Workflow Checks',
        bullets: ['Use workflows to automate checks like reminding reps about missing data or creating related records.', 'Workflows update properties in bulk and trigger tasks, freeing your team for high-value interactions with customers.']
      }, {
        timestamp: 86,
        title: 'Building Scalable Operations',
        bullets: ['Combining conditional properties, pipeline rules, and workflows removes friction and ensures data integrity throughout processes.', 'Well enforced processes create predictable, scalable operations that benefit your team and deliver better customer experiences.']
      }]
    },
    errorMessage: undefined
  },
  4763235: {
    quiz: [{
      questionTitle: "Which of the following best describes the difference between fit and engagement scores in HubSpot's dual scoring approach?",
      answers: [{
        answerOptionText: "Fit scores are based on a contact's location, and engagement scores are based on their company size",
        correct: false,
        responseTitle: '',
        responseText: 'Think about the two main categories of information you collect about a lead: who they are and what they do.'
      }, {
        answerOptionText: 'Fit scores are based on demographic information, while engagement scores are based on behavioral information',
        correct: true,
        responseTitle: '',
        responseText: 'Think about the two main categories of information you collect about a lead: who they are and what they do.'
      }, {
        answerOptionText: 'Fit scores are assigned by the marketing team, and engagement scores are assigned by the sales team',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the two main categories of information you collect about a lead: who they are and what they do.'
      }, {
        answerOptionText: 'Fit scores are assigned positive values, and engagement scores are assigned negative values',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the two main categories of information you collect about a lead: who they are and what they do.'
      }]
    }, {
      questionTitle: 'A key best practice mentioned is to align with your marketing and sales teams. Why is this alignment so crucial for effective lead scoring?',
      answers: [{
        answerOptionText: 'It helps the marketing team determine which leads to automatically disqualify',
        correct: false,
        responseTitle: '',
        responseText: 'Lead scoring is a bridge between two teams. What is the main outcome of making sure that bridge is strong?'
      }, {
        answerOptionText: 'It ensures the score is well-crafted by taking into account both the marketing and sales perspective on what an ideal customer looks like',
        correct: true,
        responseTitle: '',
        responseText: 'Lead scoring is a bridge between two teams. What is the main outcome of making sure that bridge is strong?'
      }, {
        answerOptionText: "It simplifies the process of setting up score decay, so leads don't become stale",
        correct: false,
        responseTitle: '',
        responseText: 'Lead scoring is a bridge between two teams. What is the main outcome of making sure that bridge is strong?'
      }, {
        answerOptionText: "It allows the sales team to override a lead's score once they begin a conversation",
        correct: false,
        responseTitle: '',
        responseText: 'Lead scoring is a bridge between two teams. What is the main outcome of making sure that bridge is strong?'
      }]
    }, {
      questionTitle: 'The video suggests assigning lower point values to keep scores small and manageable. What is the benefit of this approach?',
      answers: [{
        answerOptionText: "It makes it easier for the sales team to ignore a lead's score",
        correct: false,
        responseTitle: '',
        responseText: 'Think about what is easier to understand and use: a score of 987 or a score of 55? A smaller scale makes it easier to stand out.'
      }, {
        answerOptionText: "It allows you to assign negative values to a lead's score for unwanted actions",
        correct: false,
        responseTitle: '',
        responseText: 'Think about what is easier to understand and use: a score of 987 or a score of 55? A smaller scale makes it easier to stand out.'
      }, {
        answerOptionText: 'It makes it easier to identify what a truly high-performing lead looks like and where the prioritization threshold is',
        correct: true,
        responseTitle: '',
        responseText: 'Think about what is easier to understand and use: a score of 987 or a score of 55? A smaller scale makes it easier to stand out.'
      }, {
        answerOptionText: "It ensures that the scores align with your customer's journey and the stage they are in",
        correct: false,
        responseTitle: '',
        responseText: 'Think about what is easier to understand and use: a score of 987 or a score of 55? A smaller scale makes it easier to stand out.'
      }]
    }, {
      questionTitle: "What is the purpose of 'score decay' in lead scoring?",
      answers: [{
        answerOptionText: "To ensure a contact's score is always positive and never drops below zero",
        correct: false,
        responseTitle: '',
        responseText: "Think about the concept of a 'hot' lead becoming a 'cold' lead over time. What mechanism in lead scoring reflects that cooling off?"
      }, {
        answerOptionText: "To decrease a lead's score based on the time that has elapsed since their last action, to ensure the score reflects recent engagement",
        correct: true,
        responseTitle: '',
        responseText: "Think about the concept of a 'hot' lead becoming a 'cold' lead over time. What mechanism in lead scoring reflects that cooling off?"
      }, {
        answerOptionText: 'To automatically remove a contact from the CRM if their score drops below a certain threshold',
        correct: false,
        responseTitle: '',
        responseText: "Think about the concept of a 'hot' lead becoming a 'cold' lead over time. What mechanism in lead scoring reflects that cooling off?"
      }, {
        answerOptionText: "To increase a lead's score based on their demographic information",
        correct: false,
        responseTitle: '',
        responseText: "Think about the concept of a 'hot' lead becoming a 'cold' lead over time. What mechanism in lead scoring reflects that cooling off?"
      }]
    }],
    summary: {
      description: 'This lesson describes lead scoring basics, best practices for setup, aligning teams, building scores with AI and using scores effectively.',
      sections: [{
        timestamp: 4,
        title: 'Lead Scoring Overview',
        bullets: ['Lead scoring optimizes conversion by helping you identify the right people to contact at the right time.', 'This video explains what lead scoring is and offers best practices for setting it up.']
      }, {
        timestamp: 20,
        title: 'Understanding Lead Scoring',
        bullets: ['Lead scoring assigns values to leads to evaluate their likelihood of becoming customers successfully later.', 'HubSpot uses separate fit and engagement scores, measuring demographic attributes and behavioral engagement respectively, independently.', 'Score values are set for contacts based on criteria, enabling you to manage scores and monitor performance.']
      }, {
        timestamp: 60,
        title: 'Goal Setting & Alignment',
        bullets: ["Define why you're implementing lead scoring, such as prioritizing leads or qualifying marketing leads effectively.", 'Align marketing and sales on your ideal customer profile and take both perspectives into account.', "Use tools like HubSpot's Make My Persona and analyze conversion data to build your ideal buyer profile."]
      }, {
        timestamp: 88,
        title: 'Building and Adjusting Scores',
        bullets: ['Study conversion analytics or attribution reports to identify behaviors leading to conversions across the customer journey.', 'Enterprise customers can leverage AI to generate fit and engagement scores with model recommendations automatically.', 'Adjust score weightings to match the buyer journey, awarding higher points for deeper engagement actions.', 'Assign negative points or apply score decay to account for undesirable attributes or declining engagement.']
      }, {
        timestamp: 174,
        title: 'Refining & Applying Scores',
        bullets: ['Keep score values low to make it easier to identify genuinely high-performing leads quickly later.', 'Regularly update and refine your scoring strategy as you collect new data and receive feedback.', 'Use lead scores in workflows, lists, saved views, and reports to prioritize outreach and shorten sales cycles.', 'Well-crafted lead scoring enables marketing to empower sales teams, increasing conversions and revenue significantly overall.']
      }]
    },
    errorMessage: undefined
  },
  2965397: {
    quiz: [{
      questionTitle: 'Why is it helpful to have an IT professional and a marketing or salesperson on your team of stakeholders when migrating data?',
      answers: [{
        answerOptionText: "The IT person can oversee the marketing and sales teams' work to ensure accuracy",
        correct: false,
        responseTitle: '',
        responseText: 'Think about the unique knowledge each of these roles brings to the table. One is about the technical structure, and the other is about the practical use.'
      }, {
        answerOptionText: 'The marketing or salesperson can tell you how they use the data, and the IT person can provide a diagram of how objects are connected',
        correct: true,
        responseTitle: '',
        responseText: 'Think about the unique knowledge each of these roles brings to the table. One is about the technical structure, and the other is about the practical use.'
      }, {
        answerOptionText: 'The IT person can make sure the terminology is standardized and the salesperson can document the processes',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the unique knowledge each of these roles brings to the table. One is about the technical structure, and the other is about the practical use.'
      }, {
        answerOptionText: 'They are the only two roles required for a successful data migration',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the unique knowledge each of these roles brings to the table. One is about the technical structure, and the other is about the practical use.'
      }]
    }, {
      questionTitle: "When migrating data, what is the importance of documenting your team's 'ideal future state'?",
      answers: [{
        answerOptionText: 'It helps the team visualize what they wish their systems could do, which informs the selection of the best solution',
        correct: true,
        responseTitle: '',
        responseText: 'Think of this as a goal-setting exercise for your data migration. What is the ultimate goal?'
      }, {
        answerOptionText: 'It ensures that the old and new systems are identical to avoid any confusion',
        correct: false,
        responseTitle: '',
        responseText: 'Think of this as a goal-setting exercise for your data migration. What is the ultimate goal?'
      }, {
        answerOptionText: 'It is an optional step that is only necessary for large companies',
        correct: false,
        responseTitle: '',
        responseText: 'Think of this as a goal-setting exercise for your data migration. What is the ultimate goal?'
      }, {
        answerOptionText: 'It is a requirement for all HubSpot-built integrations to function properly',
        correct: false,
        responseTitle: '',
        responseText: 'Think of this as a goal-setting exercise for your data migration. What is the ultimate goal?'
      }]
    }, {
      questionTitle: "What is the recommended course of action if you can't find a HubSpot-built integration in the app marketplace for your data migration?",
      answers: [{
        answerOptionText: "Stop the data migration, as it's not possible without a native integration",
        correct: false,
        responseTitle: '',
        responseText: "If a ready-made solution isn't available, where would you look for the technical information you need to build a custom solution?"
      }, {
        answerOptionText: "Find the vendor's API documentation to confirm if the necessary information can be passed and retrieved",
        correct: true,
        responseTitle: '',
        responseText: "If a ready-made solution isn't available, where would you look for the technical information you need to build a custom solution?"
      }, {
        answerOptionText: 'Hire a developer to manually transfer all the data',
        correct: false,
        responseTitle: '',
        responseText: "If a ready-made solution isn't available, where would you look for the technical information you need to build a custom solution?"
      }, {
        answerOptionText: 'Standardize your terminology and document your processes again',
        correct: false,
        responseTitle: '',
        responseText: "If a ready-made solution isn't available, where would you look for the technical information you need to build a custom solution?"
      }]
    }, {
      questionTitle: "What is meant by 'standardize your terminology' in the context of data migration?",
      answers: [{
        answerOptionText: 'You should use the same contact names in both your old system and in HubSpot',
        correct: false,
        responseTitle: '',
        responseText: 'This step is all about making sure everyone is speaking the same language when they talk about the data in both systems.'
      }, {
        answerOptionText: "You should use a translation dictionary so that your language aligns between your old system and HubSpot, such as 'leads' in Salesforce and 'contacts' in HubSpot",
        correct: true,
        responseTitle: '',
        responseText: 'This step is all about making sure everyone is speaking the same language when they talk about the data in both systems.'
      }, {
        answerOptionText: "You should choose one team's terminology and require the others to adopt it",
        correct: false,
        responseTitle: '',
        responseText: 'This step is all about making sure everyone is speaking the same language when they talk about the data in both systems.'
      }, {
        answerOptionText: 'You should use the same object and property names in both your old system and in HubSpot',
        correct: false,
        responseTitle: '',
        responseText: 'This step is all about making sure everyone is speaking the same language when they talk about the data in both systems.'
      }]
    }],
    summary: {
      description: 'This session provides best practices for mapping data before migrating to HubSpot, from assembling teams to evaluating integration solutions.',
      sections: [{
        timestamp: 4,
        title: 'Preparing for Data Migration',
        bullets: ['Moving data to HubSpot can be overwhelming; ask proper questions and understand the task before migrating.', 'Assemble a team of stakeholders including IT and marketing or sales to provide diverse perspectives.']
      }, {
        timestamp: 12,
        title: 'Understanding Data Relationships',
        bullets: ['Ask IT for an entity relationship diagram to understand how system objects connect and clarify questions.', 'Consult marketing or salespeople to learn how data is used in practice and gather context.']
      }, {
        timestamp: 32,
        title: 'Standardizing Terminology & Processes',
        bullets: ['Standardize terminology across systems by building a translation dictionary linking HubSpot objects to other platforms.', 'Document processes and data collected at each stage, ensuring everyone understands how information flows accurately.']
      }, {
        timestamp: 59,
        title: 'Planning Future State & Integration',
        bullets: ["Explore your team's ideal future state, documenting desired system capabilities and questioning whether processes should change.", "Investigate integration solutions starting with HubSpot's app marketplace; if unavailable, review vendors' API documentation carefully."]
      }, {
        timestamp: 94,
        title: 'Aligning Stakeholders & Solutions',
        bullets: ['Take your time to align stakeholders, terminology, and use cases to choose the right integration solution.', 'A clear understanding of processes and goals helps you select integrations that meet current and future needs.']
      }]
    },
    errorMessage: undefined
  },
  5736482: {
    quiz: [{
      questionTitle: 'The video discusses the importance of anonymizing data when using AI. What is the main benefit of this practice?',
      answers: [{
        answerOptionText: 'It eliminates the need to get customer consent before collecting data',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the dual goal of using AI: getting insights while protecting your customers. How does anonymization achieve this balance?'
      }, {
        answerOptionText: 'It allows you to collect as much data as possible without any risk',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the dual goal of using AI: getting insights while protecting your customers. How does anonymization achieve this balance?'
      }, {
        answerOptionText: 'It helps you meet legal requirements in every country and region',
        correct: false,
        responseTitle: '',
        responseText: 'Think about the dual goal of using AI: getting insights while protecting your customers. How does anonymization achieve this balance?'
      }, {
        answerOptionText: 'It reduces privacy risks by stripping away personally identifiable information while still allowing AI to gain insights',
        correct: true,
        responseTitle: '',
        responseText: 'Think about the dual goal of using AI: getting insights while protecting your customers. How does anonymization achieve this balance?'
      }]
    }, {
      questionTitle: "What is one key takeaway regarding a company's responsibility in the event of a data incident?",
      answers: [{
        answerOptionText: 'The company should wait to see if the incident affects customer data before taking action',
        correct: false,
        responseTitle: '',
        responseText: 'This question is about what to do after a mistake happens. How should you communicate with your customers?'
      }, {
        answerOptionText: "How you handle the mistake can have a bigger impact on trust than the mistake itself, so it's important to be transparent and accountable",
        correct: true,
        responseTitle: '',
        responseText: 'This question is about what to do after a mistake happens. How should you communicate with your customers?'
      }, {
        answerOptionText: 'The responsibility for the breach lies with the cybersecurity team, not the marketing department',
        correct: false,
        responseTitle: '',
        responseText: 'This question is about what to do after a mistake happens. How should you communicate with your customers?'
      }, {
        answerOptionText: 'You should offer financial compensation to all affected customers, regardless of the severity of the breach',
        correct: false,
        responseTitle: '',
        responseText: 'This question is about what to do after a mistake happens. How should you communicate with your customers?'
      }]
    }, {
      questionTitle: 'The video mentions the importance of regularly auditing your AI systems. Why is this a crucial step for maintaining data privacy?',
      answers: [{
        answerOptionText: 'Audits are required to update the AI models with the latest marketing trends and data',
        correct: false,
        responseTitle: '',
        responseText: "Think about how AI systems can change over time. What problems might arise if you don't check in on them regularly?"
      }, {
        answerOptionText: "AI models are 'set it and forget it' solutions, and audits are only needed if a privacy breach occurs",
        correct: false,
        responseTitle: '',
        responseText: "Think about how AI systems can change over time. What problems might arise if you don't check in on them regularly?"
      }, {
        answerOptionText: 'Over time, AI systems can drift from their original purpose or pick up biases that may lead to privacy concerns',
        correct: true,
        responseTitle: '',
        responseText: "Think about how AI systems can change over time. What problems might arise if you don't check in on them regularly?"
      }, {
        answerOptionText: 'Audits are a way to collect more data about how the AI is performing in real-time',
        correct: false,
        responseTitle: '',
        responseText: "Think about how AI systems can change over time. What problems might arise if you don't check in on them regularly?"
      }]
    }, {
      questionTitle: 'What is the core principle of data collection when using AI for marketing?',
      answers: [{
        answerOptionText: "Collect as much data as possible, as long as you have the customer's consent",
        correct: false,
        responseTitle: '',
        responseText: 'This is a combination of two of the main principles mentioned early in the video: what you should ask for and what you should take.'
      }, {
        answerOptionText: "Only collect data that can be fully anonymized and isn't personally identifiable",
        correct: false,
        responseTitle: '',
        responseText: 'This is a combination of two of the main principles mentioned early in the video: what you should ask for and what you should take.'
      }, {
        answerOptionText: "Only collect the data you need and let people know what you're collecting and why, to get their permission",
        correct: true,
        responseTitle: '',
        responseText: 'This is a combination of two of the main principles mentioned early in the video: what you should ask for and what you should take.'
      }, {
        answerOptionText: 'Collect all the data that a customer is willing to share in exchange for a personalized experience',
        correct: false,
        responseTitle: '',
        responseText: 'This is a combination of two of the main principles mentioned early in the video: what you should ask for and what you should take.'
      }]
    }],
    summary: {
      description: 'The video outlines best practices for data privacy when using AI in marketing, covering laws, consent, minimization, anonymization, audits, incident response and culture.',
      sections: [{
        timestamp: 5,
        title: 'AI & Data Privacy Laws',
        bullets: ['AI revolutionizes marketing but handling customer data responsibly is essential to maintain trust and avoid legal issues.', 'Familiarize yourself with data privacy laws such as GDPR and CCPA when marketing to European or US audiences.', 'These laws share core principles: be transparent, obtain consent, and collect only necessary data always.']
      }, {
        timestamp: 73,
        title: 'Transparency & Consent',
        bullets: ['Before starting an AI project, ensure processes align with privacy expectations and never assume implicit consent.', 'Be upfront about data collection and get permission, explaining how information will be used and its benefits.', 'Transparency builds trust; customers will share data when they understand the purpose and value clearly.']
      }, {
        timestamp: 116,
        title: 'Minimizing Data Collection',
        bullets: ['Collect only the data necessary for your marketing objectives; hoarding extra data increases risk and responsibilities.', 'Privacy regulations require limiting data collection to essential information for your stated purposes at all times.', "Examples illustrate that collecting irrelevant details—like someone's high school GPA—does not serve marketing goals effectively."]
      }, {
        timestamp: 145,
        title: 'Anonymization Techniques',
        bullets: ['Anonymize or pseudonymize data so AI can learn without revealing personally identifiable information directly online.', 'Strip names and emails from training data, replacing them with unique identifiers to reduce privacy risk.']
      }, {
        timestamp: 186,
        title: 'Audits & Cybersecurity',
        bullets: ["Audit AI systems regularly to ensure they perform as intended and haven't drifted or introduced bias.", 'Check for vulnerabilities like weak encryption or broad access; fix issues to protect customer data.', 'Invest in strong cybersecurity: encrypt sensitive data, use secure APIs, and restrict access to necessary users.']
      }, {
        timestamp: 254,
        title: 'Incident Response',
        bullets: ['If a data incident occurs, promptly notify affected individuals, explain remediation steps, and offer support.', 'Honesty and accountability after a breach can rebuild trust and mitigate reputational damage significantly overall.']
      }, {
        timestamp: 286,
        title: 'Privacy Culture & Conclusion',
        bullets: ['Embed privacy into company culture with regular training and communication so everyone understands their role.', "A proactive privacy mindset protects customers and strengthens your brand's reputation in a trust-driven market.", "Respecting customer data isn't just ethical; it's a competitive advantage that underpins sustainable marketing success."]
      }]
    },
    errorMessage: undefined
  }
};